// react
import * as React from "react";
// global
import l10n = require("diy/util/l10n");
// local
import {Step, StepConfig} from "./Step";
import {StepData} from "../StepData";
import {Errors, Mode as ErrorsMode} from "./Errors";
import {getConfigForStep} from "../stepConfig";
import {Observable} from "diy/util/Observable";

interface ContentProps {
    stepData: StepData;
    liteVersion: boolean;
    observable?: Observable;
    onBeforeHelp?(): void;
}

const CONTENT_WIDTH_TABLET = 590;
const CONTENT_WIDTH_SCREEN = 600;

export const computeContentWidth = (liteVersion: boolean) => {
    return liteVersion ? CONTENT_WIDTH_TABLET : CONTENT_WIDTH_SCREEN;
};

export class Content extends React.Component<ContentProps, {}> {

    render() {
        return (
            <div style={{ width: "100%", height: "534px" }}>
                {this.renderStep()}
            </div>
        );
    }

    renderStep() {
        let config: StepConfig;
        try {
            config = getConfigForStep(this.props.stepData.id);
        } catch (e) {
            return (
                <Errors mode={ErrorsMode.Warning} text={l10n.getString('onboardingGuide.errors.single') } />
            );
        }
        return (
            <Step
                stepData={this.props.stepData}
                observable={this.props.observable}
                onBeforeHelp={this.props.onBeforeHelp}
                stepConfig={config}
            />
        );

    };
}



/** WEBPACK FOOTER **
 ** ./build/js/~/tslint-loader!./source/cdn/document_root/s/diy/site-admin/onboarding-guide/components/Content.tsx
 **/